"use client"

import * as LabelPrimitive from "@radix-ui/react-label"

import { cn, cva, type VariantProps } from "../utils"

const labelVariants = cva(
  `
    text-sm leading-none font-medium
    peer-disabled:cursor-not-allowed peer-disabled:opacity-70
  `,
)

function Label({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants>) {
  return (
    <LabelPrimitive.Root
      className={cn(labelVariants(), className ?? "text-xs")}
      ref={ref}
      {...props}
    />
  )
}

export { Label }
